import '@fusion/frontend-analytics/auto';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import html2canvas from 'html2canvas';
import { App } from './App';
import './index.css';

const widgetWindow = window as Window & {
  html2canvas?: typeof html2canvas;
  FFS_BACKEND_URL?: string;
  FFS_MANIFEST_URL?: string;
};

widgetWindow.html2canvas = html2canvas;
widgetWindow.FFS_BACKEND_URL =
  (import.meta.env.VITE_FFS_BACKEND_URL as string | undefined)?.trim() ||
  'https://kraken.fusionflow.dev:7788';
widgetWindow.FFS_MANIFEST_URL =
  (import.meta.env.VITE_FFS_MANIFEST_URL as string | undefined)?.trim() ||
  'https://feedback-cdn.fusionflow.dev:7788/manifest.json';

const container = document.getElementById('root');
if (!container) throw new Error('missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
